<template>
  <div class="main main--login main--background">
    <div class="container invoice-add">
      <img src="../../assets/img/geberit-logo-1.png" alt="geberit" class="login__logo">
      <p>Uzupełnij dane adresowe, aby móc korzystać z aplikacji</p>
      <form method="post" class="form" v-bind:class="{ pending: pending }" @submit="send">
        <div class="alert alert-danger" role="alert" v-if="error">
          {{ error }}
        </div>
        <div class="form__input-container">
          <input type="text" name="voivodeship" v-model="form.voivodeship" class="form__input" placeholder="Województwo"
            required>
        </div>
        <div class="form__input-container">
          <input type="text" name="city" v-model="form.city" class="form__input" placeholder="Miasto" required>
        </div>
        <div class="form__input-container">
          <input type="text" name="postal_code" v-model="form.postal_code" class="form__input"
            placeholder="Kod pocztowy" required>
        </div>
        <div class="form__input-container">
          <input type="text" name="address" v-model="form.address" class="form__input" placeholder="Adres" required>
        </div>
        <div class="form__input-container" v-for="a in agreements">
          <input type="checkbox" :name="'agree_' + a.id" :id="'agree_' + a.id" class="form__checkbox"
            v-model="a.checked" :required="a.required ? true : false">
          <label :for="'agree_' + a.id">
            <span v-if="a.required">*</span><span style="color:white" v-html="a.text"></span>
          </label>
        </div>
        <div class="form__input-container">
          <button type="submit" class="button button--blue form__submit" v-bind:disabled="pending">Zapisz
            &raquo;</button>
        </div>
        <div class="form__input-container login__forget-password">
          <a href="" class="" @click.prevent="logout">Wyloguj</a>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import AuthenticationService from '@/app/authentication/authentication.service'
import { store } from '@/app/store'

export default {
  name: 'AddressComponent',
  data() {
    return {
      error: '',
      pending: false,
      form: {
        voivodeship: '',
        city: '',
        postal_code: '',
        address: ''
      },
      agreements: []
    }
  },
  beforeRouteEnter(to, from, next) {
    /**
     * Get current user object.
     */
    Vue.axios({
      method: 'get',
      url: '/agreements',
      data: {
        type: 'register'
      }
    })
      .then(response => {
        next(vm => {
          vm.agreements = response.data.data.filter(function (a) {
            a.checked = false
            return a
          })
        })
      })
      .catch(error => next(false))
  },
  methods: {
    /**
     * Logout user.
     *
     * @return {void}
     */
    logout: function () {
      AuthenticationService.logout();
    },

    /**
     * Login method.
     *
     * @return {void}
     */
    send: function (e) {
      e.preventDefault()

      let vm = this
      vm.error = ''
      vm.pending = true

      var formData = new FormData()
      formData.append('voivodeship', this.form.voivodeship)
      formData.append('city', this.form.city)
      formData.append('postal_code', this.form.postal_code)
      formData.append('address', this.form.address)

      this.agreements.forEach(function (agreement, index, array) {
        if (agreement.checked)
          formData.append('agree_' + agreement.id, 1)
      })

      Vue.axios({
        method: 'post',
        url: '/users/' + this.$store.state.user.id,
        data: formData
      })
        .then(response => {
          if (response.data.data.user.address_id) {
            this.$toaster.success(response.data.message)
            this.$router.push('/')
          }
        })
        .catch(error => {

        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/AddressComponent.vue